import { render } from "./CompareClickDialog.vue?vue&type=template&id=6609f41e&scoped=true"
import script from "./CompareClickDialog.vue?vue&type=script&lang=js"
export * from "./CompareClickDialog.vue?vue&type=script&lang=js"

import "./CompareClickDialog.vue?vue&type=style&index=0&id=6609f41e&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6609f41e"]])

export default __exports__